import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

/**
 * InfoPopover - standardized info icon with hover/focus popover.
 * Props:
 *  id: string - unique id for popover
 *  content: node/string - popover body content
 *  ariaLabel: string - accessible label for the button
 *  placement: string - bootstrap placement (default top)
 *  delay: {show:number, hide:number}
 *  iconClass: string - icon classes (default bootstrap info circle)
 *  maxWidth: number - max width of popover
 */
const InfoPopover = ({
  id,
  content,
  ariaLabel = 'More information',
  placement = 'top',
  delay = { show: 200, hide: 150 },
  iconClass = 'bi bi-info-circle',
  maxWidth,
  className = 'info-icon-btn'
}) => {
  const overlay = (
    <Popover
      id={id}
      className="app-info-popover"
      style={{
        width: 'max-content',
        minWidth: `min(280px, calc(100vw - 24px))`,
        ...(maxWidth ? { '--app-info-popover-max-width': `${maxWidth}px` } : {}),
        minHeight: 0
      }}
    >
      <Popover.Body>{content}</Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement={placement}
      delay={delay}
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
      overlay={overlay}
    >
      <button
        type="button"
        className={className}
        aria-label={ariaLabel}
      >
        <span className={iconClass} aria-hidden="true" />
      </button>
    </OverlayTrigger>
  );
};

export default InfoPopover;
